import { ButtonBase, makeStyles } from '@material-ui/core';
import { isEmpty, map } from 'lodash';
import React, { useState } from 'react';
import config from '../../preorder/configs/config';
import ProductDetailModal from './productDetailModal/ProductDetailModal';

const useItemStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'stretch',
    background: 'white',
    borderRadius: 8,
    boxShadow: 'rgba(157,157,157,.5) 1px 1px 5px 0px',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 16,
    overflow: 'hidden',
    padding: theme.spacing(2),
    position: 'relative',
    textAlign: 'left',
    width: '100%',
  },
  block: {
    display: 'flex',
    fontWeight: 'bold',
    justifyContent: 'space-between',
  },
  sellPriceContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  discount: {
    background: theme.palette.price.onSale,
    borderRadius: 8,
    color: 'white',
    lineHeight: 1,
    marginLeft: theme.spacing(1),
    padding: theme.spacing(0.25, 1),
    fontSize: 16,
    fontWeight: 'bold',
  },
  price: {
    fontSize: 13,
    textDecoration: 'line-through',
    lineHeight: 1,
  },
  sellPrice: {
    color: theme.palette.price.onSale,
    lineHeight: 1,
    marginLeft: theme.spacing(1),
    fontSize: 18,
    fontWeight: 'bold',
  },
  name: {
    background: (props) => props.bgColor || theme.palette.campaign.main,
    borderRadius: 8,
    color: 'white',
    marginTop: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  description: {
    marginTop: theme.spacing(1),
  },
  removeDate: {
    color: theme.palette.price.onSale,
    fontSize: 14,
  },
}));

function Item({ data, onClick }) {
  const {
    discountString,
    name,
    price,
    providerName,
    removeDate,
    sellPrice,
  } = data || {};
  const classes = useItemStyle();

  return (
    <ButtonBase
      className={classes.root}
      onClick={() => {
        onClick(data);
      }}
    >
      <div className={classes.block}>
        <span>{`【${providerName}】`}</span>
        <span className={classes.removeDate}>{`下架日期：${removeDate}`}</span>
      </div>
      <div className={classes.block}>
        <span>{name}</span>
        <div className={classes.sellPriceContainer}>
          <span className={classes.price}>{`原價${price}`}</span>
          <span className={classes.discount}>{discountString}</span>
          <span className={classes.sellPrice}>{`$${sellPrice}`}</span>
        </div>
      </div>
    </ButtonBase>
  );
}

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'stretch',
    background: 'rgb(244,244,244)',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    height: '100%',
    padding: theme.spacing(2, 0),
  },
  name: {
    fontSize: 16,
  },
  description: {
    color: theme.palette.price.onSale,
    fontSize: 12,
    fontWeight: 'bold',
  },
  itemsContainer: {
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'wrap',
    marginTop: theme.spacing(1),

    '& > *': {
      padding: theme.spacing(1),
      flexBasis: '100%',

      [theme.breakpoints.up('sm')]: {
        flexBasis: '50%',
      },
    },
  },
}));

export default function MenuCampaigns({ data }) {
  const classes = useStyle();
  const [isProductDetailModalOpened, setIsProductDetailModalOpened] = useState(false);
  const [productDetailModalData, setProductDetailModalData] = useState({});

  const onItemClick = (item) => {
    setIsProductDetailModalOpened(true);
    setProductDetailModalData(item);
  };

  const onModalClose = () => {
    setIsProductDetailModalOpened(false);
    setProductDetailModalData({});
  };

  return (
    <div className={`${classes.root} fz-container fz-m-auto`}>
      <ProductDetailModal
        data={productDetailModalData}
        isOpen={isProductDetailModalOpened}
        onClose={onModalClose}
      />
      <div style={{
        display: 'flex', alignItems: 'center', paddingLeft: 16, marginTop: 8,
      }}
      >
        <img src={`${config.RESOURCE_URI}MenuAd/foodcountdown.png`} alt="" width="34px" height="34px" />
        <div style={{
          display: 'flex', flexDirection: 'column', flexGrow: 1, marginLeft: 8,
        }}
        >
          <span className={classes.name}>
            <b>倒數即食</b>
            {' '}
            | 精選機台內每日即期優惠選品
          </span>
          <span className={classes.description}>注意：請選購該下架日期商品才有折扣！</span>
        </div>
      </div>
      <div className={classes.itemsContainer}>
        {isEmpty(data)
          ? (
            <div style={{
              flexBasis: '100%',
              fontSize: 20,
              fontWeight: 'bold',
              marginTop: 16,
              textAlign: 'center',
            }}
            >
              尚無特價商品
            </div>
          )
          : map(data, (item) => {
            const { id } = item || {};

            return (
              <div className={classes.itemContainer} key={id}>
                <Item data={item} onClick={onItemClick} />
              </div>
            );
          })}
      </div>
    </div>
  );
}
